import {useSelector} from 'react-redux';

import {selectIsDeliverySkipped} from '@/state/selectors/consumer';
import {AUTO_DELIVERY_INFO_BOX_SOURCES, type AutoDeliveryInfoBoxSource} from '@/types/content';
import type {AutoDeliveryDetailsDcx} from '@/types/icc/autoDeliveryDetails';
import {AutoDeliveryDcxInfoBox} from '@/views/AutoDeliveryDcx/AutoDeliveryDcxInfoBox';

import {getActiveInfoBoxData} from './autoDeliveryDcxActive.helpers';

type AutoDeliveryDcxActiveInfoBoxProps = {
    details: AutoDeliveryDetailsDcx | undefined;
    className?: string;
    source?: AutoDeliveryInfoBoxSource;
};

export const AutoDeliveryDcxActiveInfoBox = ({
    details,
    className,
    source = AUTO_DELIVERY_INFO_BOX_SOURCES.DETAILS,
}: AutoDeliveryDcxActiveInfoBoxProps) => {
    const isDeliverySkipped = useSelector(selectIsDeliverySkipped);
    const notificationResult = getActiveInfoBoxData({details, source, isDeliverySkipped});

    if (!notificationResult) return null;

    return <AutoDeliveryDcxInfoBox data={notificationResult} className={className} source={source} />;
};
